if (__DEV__) {
	module.exports = require('./UrlPrefix.dev');
} else {
	module.exports = require('./UrlPrefix.prod');
}